// 倒计时
function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
        setupNewCountdown();
        leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
        leftM = Math.floor((leftTime / (1000 * 60)) % 60),
        leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
        hour: leftH,
        minute: leftM,
        second: leftS,
    };
}
function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
        let cutDownTimeText = cutDownTime();
        $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
        $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
        $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
    }, 1000);
}

getCutDownTime();

function mainRender() {
    $(function () {
        $("#root").css("zoom", "normal");
        let scale = document.body.clientWidth / 1080;
        $("#root").css("zoom", scale);

        window.addEventListener(
            "resize",
            (function () {
                var timer;
                return function () {
                    if (timer) clearTimeout(timer);
                    timer = setTimeout(function () {
                        $("#root").css("zoom", "normal");
                        let scale = document.body.clientWidth / 1080;
                        $("#root").css("zoom", scale);
                    }, 100);
                };
            })()
        );
    });

    function lazyLoadImages() {
        // 懒加载
        const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
        const config = {
            rootMargin: "0px 0px 1300px 0px",
            threshold: 0,
        };

        const lazyLoadObserver = new IntersectionObserver(function (
            entries,
            observer
        ) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    // 当图片进入视口时
                    const image = entry.target;
                    const dataSrc = image.getAttribute("data-src");
                    image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
                    lazyLoadObserver.unobserve(image); // 停止观察该图片
                }
            });
        },
            config);

        images.forEach(function (image) {
            lazyLoadObserver.observe(image); // 开始观察每个图片
        });
    }

    function preloadImages(imageArray) {
        // 预加载
        // 检查数组数据结构
        if (Array.isArray(imageArray[0])) {
            // 处理二维数组
            imageArray.forEach((subArray) => {
                subArray.forEach((url) => {
                    const img = new Image();
                    img.src = url;
                });
            });
        } else {
            // 处理一维数组
            imageArray.forEach((url) => {
                const img = new Image();
                img.src = url;
            });
        }
    };
  
    document.addEventListener("DOMContentLoaded", function () {
        lazyLoadImages();
      var imgArr = [
            // 'https://cdn.shopify.com/s/files/1/0726/3715/3597/files/20250606-pro2.png?v=1749200497',
            // 'https://cdn.shopify.com/s/files/1/0726/3715/3597/files/20250606-pro3.png?v=1749200497',
            // 'https://cdn.shopify.com/s/files/1/0726/3715/3597/files/20250606-pro4.png?v=1749201145',
            'https://cdn.shopify.com/s/files/1/0726/3715/3597/files/20250606-img4.png?v=1750836715',
            "https://cdn.shopify.com/s/files/1/0726/3715/3597/files/20250609-img2.png?v=1750837894",
            "https://cdn.shopify.com/s/files/1/0726/3715/3597/files/20250609-img5.png?v=1750837894",

            'https://cdn.shopify.com/s/files/1/0603/2900/1069/files/1_c1a57bdf-8887-4cb6-87b2-7d0907d40240.png?v=1772619025',
            'https://cdn.shopify.com/s/files/1/0603/2900/1069/files/2_26f77fa7-ea78-4dbe-811f-30c7da189a7c.png?v=1772619025',
            'https://cdn.shopify.com/s/files/1/0603/2900/1069/files/3_8aa6c96c-679c-46e3-a2dc-d08647d7d23e.png?v=1772619025',
            "https://cdn.shopify.com/s/files/1/0726/3715/3597/files/20250609-img4.png?v=1750836803",
            "https://cdn.shopify.com/s/files/1/0726/3715/3597/files/20250606-pro3.png?v=1749200497",
            "https://cdn.shopify.com/s/files/1/0726/3715/3597/files/20250606-pro4.png?v=1749201145",
            "https://cdn.shopify.com/s/files/1/0726/3715/3597/files/20250606-img6.png?v=1749198288",
            "https://cdn.shopify.com/s/files/1/0726/3715/3597/files/20250606-pro5.png?v=1749201145",
            "https://cdn.shopify.com/s/files/1/0726/3715/3597/files/20250606-pro6.png?v=1749201145"

        ]
      preloadImages(imgArr);
        new Swiper(".sp-swiper1", {
            autoplay: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            slideShadows: true,
            slidesPerView: "auto",
            spaceBetween: 0,
            centeredSlides: true,
            loop: true,
            pagination: {
                el: ".sp-pagination",
                clickable: true,
            },
        });
        let prods = window.product
        console.log(prods, 'prods')
        function getCur() {
            let color = $('#color div.active').attr('data-val')
            // const size = $('#size div.active').attr('data-val')
            // return prods.filter(item => item.option1 == color && item.option2 == size)[0]
            return prods.filter(item => item.option1 == color)[0]
        }
        function changePrice() {
            let num = $('#calcNumber').val()
            let price = (getCur().price * num / 100).toFixed(2)
            let compare = (getCur().compare_at_price * num / 100).toFixed(2)
            price = (price + '').replace('.', ',')
            compare = (compare + '').replace('.', ',')
            $('#new').html(price)
            $('#old').html(compare)
            let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
            $(".product-part .sp-free span").html(`${off_font}`)
        }
        $('.sp-btn-style').click(function () {
            let num = $('#calcNumber').val()
            window.location.href = '/cart/' + getCur().id + ':' + num
        })
        //加减
        $('.reduce').click(function () {
            let input = $(this).siblings('input')[0]
            let num = Number(input.value) - 1
            if (num > 0) {
                input.value = num
            }
            var number = Number($('#calcNumber').val())
            changePrice()
        })
        $('.add').click(function () {
            let input = $(this).siblings('input')[0]
            let num = Number(input.value) + 1
            input.value = num
            var number = Number($('#calcNumber').val())
            changePrice()
        })
        
        $('.option').click(function () {
            $(this).siblings().removeClass('active')
            $(this).addClass('active')
            changePrice()
        })

        // style选项
        let typeOptions = $('.option')
        // 切换选项
        typeOptions.click(function () {
            let index = $(this).index()
            changeOption()
        })
        function changeOption() {
            var index = $('#color .option.active').index()
            const size = $('#size .option.active').index()
            // $('.top-product>img').attr('src', imgArr[index + size*3])
            $('.top-product>img').attr('src', imgArr[index])
            if (index == 0) {
                $('.top-product>img').css({
                    width: '400px'
                    // marginTop: '84px'
                })
            } else if (index == 1) {
                $('.top-product>img').css({
                    width: '490px'
                    // marginTop: '102px'
                })
            }else if (index == 2) {
                $('.top-product>img').css({
                     width: '588px'
                    //   marginTop: '133px'
                })
            } else {
              $('.top-product>img').css({
                    width: '558px'
                // marginTop: '110px'
                })
                
            }
        }
            //   if (index == 0) {
            //     if (size == 1 || size == 3) {
            //       $('.top-product>img').css({
            //         width: '20%',
            //         marginTop: '96px'
            //       })
            //     }else{
            //       $('.top-product>img').css({
            //         width: '70%',
            //         marginTop: '0px'
            //       })
            //     }
            //   }else{
            //       $('.top-product>img').css({
            //         width: '70%',
            //         marginTop: '0px'
            //       })
            //     }
            // }
            addCart()
            function addCart() {
                // 加入购物车
                $('#addCart').click(function () {
                    var data = {
                        id: getCur().id,
                        quantity: $('#calcNumber').val(),
                    };
                    $.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        data: data,
                        success: function () {
                            $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
                                $("#cardNum").html(result.item_count);
                                $("#cardNum").removeClass("sp-gray");
                            });
                        },
                        dataType: "json",
                    });
                    var img = $('.top-product img')
                    var flyer = img[0].cloneNode(true)
                    flyer.classList.add('clone')
                    $('.product-part').append(flyer)
                    $('.clone').css({
                        width: img.width(),
                        height: img.height(),
                        position: 'fixed',
                        top: img[0].offsetTop,
                        left: img.offset().left,
                        'z-index': '99',
                    })
                    var offset = $('.sp-cart')[0].getBoundingClientRect()
                    $('.sp-cart').addClass('shake')
                    setTimeout(() => {
                        $('.sp-cart').removeClass('shake')
                    }, 1000)
                    let finish = $('.sp-cart')
                    $('.clone').animate(
                        {
                            top: finish[0].offsetTop ,
                            left: finish[0].offsetLeft + finish.width() / 2 - 9,
                            width: 50, // 结束时的大小，根据需要调整
                            height: 50, // 结束时的大小，根据需要调整
                            opacity: 0.4,
                        },
                        1000,
                        'linear',
                        function () {
                            $(this).animate(
                                {
                                    width: 0,
                                    height: 0,
                                    opacity: 0,
                                },
                                0,
                                function () {
                                    $(this).detach() // 完成动画后移除克隆的图片
                                }
                            )
                        }
                    )
                })
            }

            // 找到所有跳转套餐的锚点链接
            var links = document.querySelectorAll('a[href^="#shopping"]');
            links.forEach(function (link) {
                link.addEventListener("click", function (event) {
                    event.preventDefault(); // 阻止默认的跳转行为
                    // var targetElement = document.getElementById('shopping');
                    // if (targetElement) {
                    //     targetElement.scrollIntoView({ behavior: 'smooth' });
                    // } // 方式一
                    const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
                    const offsetTop = targetElement.offsetTop;
                    window.scroll({
                        top: offsetTop * $("div#root").css("zoom") - 240 * $("div#root").css("zoom"),
                        behavior: "smooth", // 使用 smooth 实现平滑滚动
                    }); // 方式二
                });
            });
        });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
        console.log("Android");
    } else if (isIOS) {
        console.log("iOS");
    } else if (isPC) {
        console.log("PC");
    } else {
        $(".sp_system").css("letter-spacing", "-4px");
    }
}

mainRender();